<template>
  <b-card :class="'border-left-' + variant">
    <div class="row no-gutters align-items-center">
      <div class="col mr-2">
        <slot>
          <div :class="'font-weight-bold text-uppercase mb-1 text-' + variant">
            <b-badge pill :variant="variant">{{ badge }}</b-badge>
          </div>
          <div v-if="name" class="h6 mb-0 font-weight-bold text-gray-800">
            {{ name }}
          </div>
          <div v-if="device" class="h6 mb-0 font-weight-bold text-gray-800">
            Aparelho: {{ device }}
          </div>
          <div v-if="date" class="h6 mb-0 font-weight-bold text-gray-800">
            Momento da Solicitação: {{ date }}
          </div>
          <div v-if="dateReport" class="h6 mb-0 font-weight-bold text-gray-800">
            Resultado Enviado: {{ dateReport }}
          </div>
        </slot>
      </div>      
    </div>
  </b-card>
</template>

<script>
export default {
  name: "QueueCard",
  props: {
    variant: {
      type: String,
      default: 'primary'
    },
    badge: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    device: {
      type: String,
      default: null
    },
    date: {
      type: String,
      default: null
    },
    dateReport: {
      type: String,
      default: null
    }
  },
  computed: {
    smallScreen() {
      return window.innerWidth <= 680
    }
  }
}
</script>

<style scoped>

</style>
